<template>
  <div class="question-wrap" ref="questionWrapRef">
    <div class="question-wrap-left" v-if="qaType == '1'">
      <el-scrollbar always>
        <el-menu :default-active="taxActive" @select="menuSelect">
          <el-tooltip :content="title" placement="right">
            <el-text truncated>{{ title }}</el-text>
          </el-tooltip>

          <el-menu-item-group>
            <el-menu-item v-for="(item, index) of taxList" :key="index" :index="item.type">
              <el-text truncated>{{ item.title }}</el-text>
            </el-menu-item>
          </el-menu-item-group>
        </el-menu>
      </el-scrollbar>
    </div>

    <div class="question-wrap-right">
      <div v-if="qaType != '1'" style="display: flex; flex-direction: row-reverse; padding: 5px 10px 5px 0">
        <el-button plain style="margin-left: 15px" @click="emit('save')" type="primary">暂存</el-button>
        <el-button plain type="primary">上传附送资料</el-button>
      </div>
      <el-scrollbar class="el-scrollbar-question-wrap-right" always>
        <component :is="view" ref="viewRef" />
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
// 1.填报增值税及附加税（小规模纳税人）
import { nextTick, toRaw } from "vue";
import { ElMessage } from "element-plus";
import { cloneDeep } from "lodash";

import tax11 from "./cmp/tax11.vue";
import tax12 from "./cmp/tax12.vue";
import tax13 from "./cmp/tax13.vue";
import tax14 from "./cmp/tax14.vue";

const props = defineProps({
  qaType: {
    // 页面类型，默认为1即原始的设置题目，通过菜单切题页面。 其他情况为组件名称即： tax11,tax12,tax13,tax14,
    type: String,
    default: "1",
  },
});

watch(
  () => props.qaType,
  (newVal) => {
    if (newVal == "1") {
      return;
    }
    //nextTick(() => {
    menuSelect(newVal);
    //});
  },
  { immediate: true }
);

const emit = defineEmits(["save", "taxSave"]);

const viewRef = ref();
const isDev = ref(import.meta.env.DEV);
const isSet = ref(location.search.includes("isSet=111"));
const title = ref("1.填报增值税及附加税（小规模纳税人）");
const taxList = ref([
  {
    title: "1.1增值税及附加税费申报表（小规模纳税人适用）",
    type: "tax11",
  },
  {
    title: "1.2增值税及附加税费申报表（小规模纳税人适用）附列资料（一）",
    type: "tax12",
  },
  {
    title: "1.3增值税及附加税费申报表（小规模纳税人适用）附列资料（二）",
    type: "tax13",
  },
  {
    title: "1.4增值税减免税申报明细表",
    type: "tax14",
  },
]);
const taxActive = ref("tax11");
const view = shallowRef(null);
const views = {
  tax11,
  tax12,
  tax13,
  tax14,
};
view.value = views[taxActive.value];

const mode = ref(null);
const taxDataAll = ref({
  tax11: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(25, 4),
      // 考题设置数据
      // 考题设置数据 - 数字数据
      v1x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v10x1: {
        value: 0,
        answer: null,
        score: null,
      },
      v22x1: {
        value: 0,
        answer: null,
        score: null,
      },
    },
  },
  tax12: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(4, 4),
    },
  },
  tax13: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(4, 9),
      // 文本数据
      v1x4: {
        value: "",
      },
      v2x4: {
        value: "",
      },
      v3x4: {
        value: "",
      },
      // 考题设置数据
      // 考题设置数据 - 选择框数据
      v1x2: {
        value: "0.07",
        answer: "0.07",
        score: null,
      },
      v2x2: {
        value: "0.03",
        answer: "0.03",
        score: null,
      },
      v3x2: {
        value: "0.02",
        answer: "0.02",
        score: null,
      },
      // 考题设置数据 - 数字数据
      v1x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x5: {
        value: 0,
        answer: null,
        score: null,
      },
      v1x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x6: {
        value: 0,
        answer: null,
        score: null,
      },
      // 本地开发测试数据
      /* ...(isDev.value
      ? {
          v1x1: {
            value: 100,
          },
          v2x1: {
            value: 200,
          },
          v3x1: {
            value: 300,
          },
        }
      : {}), */
    },
  },
  tax14: {
    status: 0, // 0 未填写 1 已填写
    // 表单数据
    data: {
      // 基础数字数据
      ...createData(14, 7),
      // 考题设置数据
      // 考题设置数据 - 选择框数据
      v2x1: {
        value: "0",
        answer: null,
        score: null,
      },
      v3x1: {
        value: "0",
        answer: null,
        score: null,
      },
      v4x1: {
        value: "0",
        answer: null,
        score: null,
      },
      v5x1: {
        value: "0",
        answer: null,
        score: null,
      },
      v6x1: {
        value: "0",
        answer: null,
        score: null,
      },
      // 考题设置数据 - 数字数据
      v2x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v2x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v3x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v4x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v4x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v5x6: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x4: {
        value: 0,
        answer: null,
        score: null,
      },
      v6x6: {
        value: 0,
        answer: null,
        score: null,
      },
      // 选择框数据
      v10x1: {
        value: "0",
      },
      v11x1: {
        value: "0",
      },
      v12x1: {
        value: "0",
      },
      v13x1: {
        value: "0",
      },
      v14x1: {
        value: "0",
      },
    },
  },
});
// 初始化
const taxInit = (options = {}) => {
  nextTick(() => {
    try {
      // 合并数据
      mode.value = options.mode;
      if (options.taxDataAll) {
        taxDataAll.value = options.taxDataAll;
      }

      // 当前税表数据
      const taxData = taxDataAll.value[taxActive.value];
      console.log("初始化数据", {
        mode: mode.value,
        taxDataAll: toRaw(taxDataAll.value),
        taxData: toRaw(taxData),
      });
      // 初始化
      viewRef.value.init({
        mode: mode.value,
        taxDataAll: toRaw(taxDataAll.value),
        taxData: toRaw(taxData),
      });
    } catch (e) {
      console.log(e);
    }
  });
};
// 切换税表
const menuSelect = (value) => {
  // 暂存
  if (mode.value == 1) {
    taxSave(1);
  } else {
    taxSave(2);
    emit("taxSave", { showLoading: false });
  }
  taxActive.value = value;
  view.value = views[value];
};
// 合并选项 合并选项操作只做一次
const taxInitOptionsExtendDone = ref(false);
const taxInitOptionsExtend = (options) => {
  if (!taxInitOptionsExtendDone.value) {
    mode.value = options.mode;
    if (options.taxDataAll) {
      taxDataAll.value = options.taxDataAll;
    }

    taxInitOptionsExtendDone.value = true;
  }
};
// 保存
const taxSave = (type = 1) => {
  // type
  // 1 暂存 不更新填写状态 不根据联表映射规则更新其他tax数据 不发送给后端
  // 2 保存 更新填写状态 根据联表映射规则更新其他tax数据 发送给后端
  console.log(`${["临时", "正式"][type - 1]}保存`);
  try {
    const getData = viewRef.value.getData;

    if (typeof getData === "function" && getData()) {
      // 1
      console.log("当前保存表格为", taxActive.value);
      // 2
      const _data = cloneDeep(getData());
      console.log("当前保存表格数据为", _data);
      // 3
      const _taxDataAll = cloneDeep(toRaw(taxDataAll.value));
      console.log("当前所有表格数据为", _taxDataAll);
      // 4
      _taxDataAll[taxActive.value].data = _data;
      console.log("更新当前保存表格数据到所有表格数据", _taxDataAll);

      if (type == 2) {
        // 5
        if (mode.value == 1) {
          _taxDataAll[taxActive.value].status = 1;
        }
        console.log("做题模式下，更新填写状态", _taxDataAll);
        // 6
        if ([1, 2, 5].includes(+mode.value)) {
          // ElMessage.warning("todo 做题模式下，根据联表映射规则更新其他tax数据");
          taxDataAllUpdate(taxActive.value, _taxDataAll);
        }
      }

      // 重新初始化
      taxInit({
        mode: mode.value, // 1 做题 2 设置题目 3 查看结果 4 查看答案
        taxDataAll: _taxDataAll, // 只有新建题目不需要传入taxDataAll 修改题目，做题，查看结果都需要传入
      });

      console.log("最终返回数据", _taxDataAll);
      return _taxDataAll;
    }
  } catch (e) {
    console.log(e);
  }
};

const questionWrapRef = ref();
const setHeight = () => {
  const $el = questionWrapRef.value;
  $el.style.height = `calc(100vh - ${$el.getBoundingClientRect().top}px - 10px)`;
};

onMounted(() => {
  setHeight();
});

// 联表做题逻辑
function taxDataAllUpdate(taxActive, taxDataAll) {
  console.log("做题模式下，根据联表映射规则更新其他tax数据", taxActive, taxDataAll);

  const tax11 = () => {
    // tax11保存时 将tax11第22行第1列数值 带入tax13 第1,2,3行第1列数值
    taxDataAll.tax13.data.v1x1.value = taxDataAll.tax11.data.v22x1.value;
    taxDataAll.tax13.data.v2x1.value = taxDataAll.tax11.data.v22x1.value;
    taxDataAll.tax13.data.v3x1.value = taxDataAll.tax11.data.v22x1.value;
  };

  const tax13 = () => {
    // tax13保存时
    // 将tax13第9行第1行数值 带入tax11 第23行第1列数值
    // 将tax13第9行第2行数值 带入tax11 第24行第1列数值
    // 将tax13第9行第3行数值 带入tax11 第25行第1列数值
    taxDataAll.tax11.data.v23x1.value = taxDataAll.tax13.data.v1x9.value;
    taxDataAll.tax11.data.v24x1.value = taxDataAll.tax13.data.v2x9.value;
    taxDataAll.tax11.data.v25x1.value = taxDataAll.tax13.data.v3x9.value;
  };

  const tax14 = () => {
    // tax14保存时 将tax14第2行第4列数值 带入tax11 第16行第1列数值
    taxDataAll.tax11.data.v16x1.value = taxDataAll.tax14.data.v2x6.value;
  };

  const taxDataAllUpdateFn = {
    tax11,
    tax13,
    tax14,
  }[taxActive];

  typeof taxDataAllUpdateFn === "function" && taxDataAllUpdateFn();
}

// 构造数字输入框数据
function createData(x = 10, y = 10) {
  const data = {};
  for (let i = 1; i <= x; i++) {
    for (let j = 1; j <= y; j++) {
      data[`v${i}x${j}`] = {
        value: isSet.value ? +`${i}${j}` : 0,
      };
    }
  }

  return data;
}

defineExpose({
  taxInit,
  taxSave,
});
</script>

<style lang="scss" scoped></style>
